import { QueryClient } from '@tanstack/react-query'
import { isApiError } from './errors'

export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (isApiError(error) && !error.retryable) return false
  return failureCount < 2
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: shouldRetry,
        retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
      },
      mutations: { retry: false },
    },
  })
}
